import { Component } from "preact";
import PropTypes from "prop-types";
import { APIConnector, ArrayUtils, Calc, combineClasses, get, Jiffy, SortRules } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import { M_StorageUnit } from "../../../models/Models_Location";
import withStorageUnit from "../../../components/shared/hoc/withStorageUnit";
import ErrorBlock from "../../../components/shared/ErrorBlock";
import Interpret from "../../../components/shared/Localization/Interpret";
import Fa from "../../../components/shared/Fa";
import ValueWithUnit from "../../../components/shared/ValueWithUnit";
import { E_Format_Unit } from "../../../models/constants/Enums_FormatUtils";
import { CurrencyProvider, Price } from "../../../components/components";
import { E_Route } from "../../../models/constants/Enum_Routes";
import { StorageUtils } from "../../../utils/StorageUtils";
import { E_RentWizard_Section } from "../../../models/constants/Enums_RentWizard";
import { route } from "preact-router";

class RentWizardTariff extends Component {
	_renderDimensions(dimensionsDetail) {
		if(dimensionsDetail.x && dimensionsDetail.y && dimensionsDetail.z) {
			return (
				<div className={"graphics"}>
					<Fa icon={"cube-light"}/>

					<div className={"dimension dimension-x"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.x / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>

					<div className={"dimension dimension-y"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.y / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>

					<div className={"dimension dimension-z"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.z / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>
				</div>
			)
		}

		return (
			<div className={"dimensions-text"}>
				<Interpret id={dimensionsDetail.dimensionsText}/>
			</div>
		);
	}

	_renderServiceTypeContent(serviceType) {
		if(!serviceType) return null;

		const {bracketID, onBracketSelected} = this.props;
		const timeBrackets = [...get(serviceType, "tariff.timeBrackets", [])];
		timeBrackets.sort((a,b) => SortRules.propertyAsc(a,b, "price"));

		return (
			<div className={"service-type"}>
				<div className={"dimensions"}>
					{this._renderDimensions(serviceType.dimensionsDetail)}
				</div>

				<div className={"time-brackets"}>
					<CurrencyProvider currency={serviceType.tariff.currency}>
						<ButtonsConstructor buttons={timeBrackets.map(bracket => {
							return {
								text: (
									<Interpret
										id={"timeBracketUpToTime"}
										params= {{
											price: <b><Price value={bracket.price} removeFractionsIfZero={true}/></b>,
											time: <b>{Jiffy.readableDuration(bracket.maxMinutes * 60000)}</b>,
										}}
									/>
								),
								action: () => {
									onBracketSelected(bracket.id);

									//Automatically continue when there is only one bracket available
									if(timeBrackets.length == 1) {
										route(E_Route.RENT_WIZARD(E_RentWizard_Section.CONTACT));
									}
								},
								active: bracket.id == bracketID,
							}
						})}/>
					</CurrencyProvider>
				</div>

				<ButtonsConstructor buttons={[
					{
						text: "ok",
						disabled: !bracketID,
						href: E_Route.RENT_WIZARD(E_RentWizard_Section.CONTACT),
						linkProps: {className: "ok-button"},
					}
				]}/>
			</div>
		)
	}

	_renderContent() {
		const {unit, unitID, serviceTypeID, onTypeSelected} = this.props;

		if(!unit.id) {
			return <ErrorBlock error={APIConnector.getErrorFromCode(404)} errorOverrides={{
				404: {
					title: "location.unit.notFound",
					message: '#' + unitID,
				}
			}}/>
		}

		const uniqueServiceTypes = StorageUtils.getServiceTypeForSelectionFromUnit(unit);
		uniqueServiceTypes.sort(SortRules.idAsc);

		return (
			<>
				<h1><Interpret id={"selectBoxAndTariff"}/></h1>

				<div className={"box-type-selection"}>
					<ButtonsConstructor buttons={uniqueServiceTypes.map(serviceType => {
						return {
							text: serviceType.titles,
							action: () => onTypeSelected(serviceType.id),
							active: serviceType.id == serviceTypeID,
						}
					})}/>
				</div>

				{this._renderServiceTypeContent(ArrayUtils.findByID(uniqueServiceTypes, serviceTypeID))}
			</>
		)
	}

	render({className, style}) {
		return (
			<section className={combineClasses("rent-wizard-tariff", className)} style={style}>
				{this._renderContent()}
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			bracketID: PropTypes.number,
			serviceTypeID: PropTypes.number,

			onBracketSelected: PropTypes.func.isRequired,
			onTypeSelected: PropTypes.func.isRequired,

			//withStorageUnit
			unitID: PropTypes.number,
			unit: PropTypes.object,
		}
	}

	static get defaultProps() {
		return {
			unit: M_StorageUnit,
		}
	}
}

export default withStorageUnit(RentWizardTariff);
